export const StorageAdapter = {
  _store: new Map(),
  _listeners: new Set(),
  _idCounter: 0,

  _notify() {
    this._listeners.forEach((fn) => fn());
  },

  subscribe(fn) {
    this._listeners.add(fn);
    return () => this._listeners.delete(fn);
  },

  async addItem(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const id = `media_${Date.now()}_${this._idCounter++}`;
        const type = file.type.startsWith("image/")
          ? "image"
          : file.type.startsWith("video/")
            ? "video"
            : file.type === "application/pdf"
              ? "pdf"
              : "other";

        const item = {
          id,
          name: file.name,
          type,
          mimeType: file.type,
          size: file.size,
          dataUrl: reader.result,
          createdAt: Date.now(),
        };

        if (type === "video") {
          const video = document.createElement("video");
          video.preload = "metadata";
          video.muted = true;
          video.playsInline = true;
          video.src = reader.result;
          video.onloadeddata = () => {
            video.currentTime = 1;
          };
          video.onseeked = () => {
            const canvas = document.createElement("canvas");
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            canvas.getContext("2d").drawImage(video, 0, 0);
            item.thumbnail = canvas.toDataURL("image/jpeg", 0.6);
            item.duration = Math.round(video.duration);
            this._store.set(id, item);
            this._notify();
            resolve(item);
          };
          video.onerror = () => {
            this._store.set(id, item);
            this._notify();
            resolve(item);
          };
        } else {
          if (type === "pdf") {
            item.blobUrl = URL.createObjectURL(file);
          }
          this._store.set(id, item);
          this._notify();
          resolve(item);
        }
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  },

  async getAll() {
    return Array.from(this._store.values()).sort(
      (a, b) => b.createdAt - a.createdAt
    );
  },

  async getByType(type) {
    const all = await this.getAll();
    return all.filter((item) => item.type === type);
  },

  async deleteItem(id) {
    this._store.delete(id);
    this._notify();
  },
};

// In storageAdapter.js — add this function

export async function saveCroppedImage(croppedDataUrl) {
  const res = await fetch(croppedDataUrl);
  const blob = await res.blob();
  const file = new File([blob], `crop_${Date.now()}.png`, { type: "image/png" });
  await StorageAdapter.addItem(file);
}